import { memo } from "react";
import OwnerMilkrecordingSelect from "../../components/multiforms/OwnerMilkrecordingSelect";

const CreateAnimalMilkRecording = () => {
    return (
        <OwnerMilkrecordingSelect type={"CreateAnimalMilkRecording"} />
    )
}

export default memo(CreateAnimalMilkRecording);